import React from 'react';
import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

import { ColorModeContext } from '../../../context/color-context';
import { COLORS } from '../../../utils/ColorsTheme';
import './_toggle.scss';

const Toggle: React.FC = () => {
  const theme = useTheme();
  const colorMode = React.useContext(ColorModeContext);
  const isDarkMode = theme.palette.mode === 'dark';
  const iconColor = isDarkMode ? COLORS.darkModeColor : COLORS.lightModeColor;

  return (
    <IconButton
      sx={{ ml: 1 }}
      onClick={colorMode.toggleColorMode}
      color='inherit'
      data-testid='toggle-button'
    >
      {theme.palette.mode === 'dark' ? (
        <Brightness7Icon htmlColor={iconColor} />
      ) : (
        <Brightness4Icon htmlColor={iconColor} />
      )}
    </IconButton>
  );
};

export default Toggle;
